// eslint-disable-next-line max-classes-per-file
export class SystemError extends Error {
  name = 'SystemError';

  type = 'system';
}

export class BusinessError extends Error {
  name = 'BusinessError';

  type = 'business';
}

export class HttpCancelError extends SystemError {
  constructor(
    protected request: any,
    protected response: any,
    message: string,
  ) {
    super(message);
    this.name = 'HttpCancelError';
  }
}

export class HttpSystemError extends SystemError {
  constructor(
    protected request: any,
    protected response: any,
    message: string,
  ) {
    super(message);
    this.name = 'HttpSystemError';
  }
}

export class HttpBusinessError extends BusinessError {
  constructor(message: string) {
    super(message);
    this.name = 'HttpBusinessError';
  }
}
